import React from "react";

function FooterPage() {
  return (
    <>
      <style>{`
		.footer {
		  background: linear-gradient(
		    270deg,
		    #ffe3e3,
		    #fff5f0,
		    #f3f0ff,
		    #e0f7fa,
		    #e8f5e9,
		    #fffde7,
		    #ffe3e3
		  );
		  background-size: 1000% 100%;

		  animation: smoothFlowFooter 25s linear infinite;

		  padding: 30px 20px 15px;
		  font-family: 'Poppins', 'Segoe UI', sans-serif;
		  border-top: 3px solid #d32f2f;
		  margin-top: auto;

		  box-shadow: 0 -3px 10px rgba(0,0,0,0.05);
		}
        .footer-container {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 30px;
        }

        .footer-left {
          max-width: 400px;
        }

        .footer-logo {
          width: 60px;
          margin-bottom: 10px;
        }

        .footer-title {
          font-size: 18px;
          font-weight: 700;
          color: #1a237e;
          margin-bottom: 8px;
        }

        .footer-text {
          font-size: 13px;
          color: #555;
          line-height: 1.6;
        }

        .footer-contact {
          font-size: 13px;
          color: #333;
          line-height: 1.8;
        }

        .footer-contact span {
          display: block;
        }

        /* SOCIAL ICONS */
        .social-icons {
          display: flex;
          justify-content: center;
          gap: 12px;
          margin-top: 20px;
        }

        .icon-circle {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          border: 1px solid #ccc;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 16px;
          color: #555;
          background: #fff;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .icon-circle:hover {
          background: #2f55d4;
          color: #fff;
          border-color: #2f55d4;
          transform: translateY(-3px);
        }

        .footer-bottom {
          text-align: center;
          margin-top: 15px;
          font-size: 12px;
          color: #666;
          border-top: 1px solid #ddd;
          padding-top: 10px;
        }

        /* Responsive */
        @media (max-width: 600px) {
          .footer-container {
            flex-direction: column;
          }
        }
      `}</style>

      <div className="footer">

        <div className="footer-container">

          {/* LEFT */}
          <div className="footer-left">
            <img src="/ASTU_JMEE_JLEE/img/astulogo.png" alt="logo" className="footer-logo" />

            <div className="footer-title">
              Assam Science and Technology University
            </div>

            <div className="footer-text">
              Assam Science and Technology University is a premier institution in Assam dedicated to excellence in technical education, research, and innovation.
            </div>
          </div>

          {/* CONTACT */}
          <div className="footer-contact">
            <span>📍 Guwahati, Assam, India</span>
            <span>📞 8108014947</span>
			<span>📞 7977259728</span>
            <span>✉️ otherexams@astu.ac.in</span>
            <span>🌐 www.astu.ac.in</span>
          </div>

        </div>

        {/* 🔥 SOCIAL ICONS */}
        <div className="social-icons">
          <div className="icon-circle">f</div>
          <div className="icon-circle">X</div>
          <div className="icon-circle">📷</div>
          <div className="icon-circle">▶</div>
        </div>

        {/* BOTTOM */}
        <div className="footer-bottom">
          © 2026 ASTU, Assam. All Rights Reserved. <br />
          Developed by IT Cell, ASTU Assam
        </div>

      </div>
    </>
  );
}

export default FooterPage;